export function toSlugStringUtil (str) {
  str = str.replace(/^\s+|\s+$/g, '')
  str = str.toLowerCase()

  // remove accents, swap ñ for n, etc
  const from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;'
  const to = 'aaaaeeeeiiiioooouuuunc------'
  for (let i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
  }

  // remove invalid chars
  str = str.replace(/[^a-z0-9 -]/g, '')

  // collapse whitespace and replace by -
  str = str.replace(
    /\s+/g,
    '-'
  )

  // collapse dashes
  str = str.replace(
    /-+/g,
    '-'
  )

  // remove dash at the end of a slug
  if (str[str.length - 1] === '-') {
    str = str.slice(str, str.length - 1)
  }

  return str
}
